import {useEffect, useState} from "react";
import {fetchNewsItems} from "../handlers/NewsHandler";
import {NewsModel} from "../models/NewsModel";
import {Button, Caption1, Spinner, Title1} from "@fluentui/react-components";
import { ArrowCircleRightRegular } from '@fluentui/react-icons';
import NewsItem from "./news/NewsItem";
import {navigateToPage} from "../handlers/RouteHandler";
import {isUserAdmin, isUserLoggedIn} from "../handlers/UserHandler";
import NewsDialog from "./news/NewsDialog";

const News = ({ showAllNewsItems = false }) => {
    const [isLoading, setIsLoading] = useState(true);
    const [newsItems, setNewsItems] = useState(new Array<NewsModel>());
    const [showMoreButton, setShowMoreButton] = useState(false);
    const [error, setError] = useState(``);
    const [isAdmin, setIsAdmin] = useState(false);

    useEffect(() => {
        fetchNews();

        isUserAdmin().then((r) => setIsAdmin(r));
    }, []);

    const fetchNews =  () => {
        fetchNewsItems(showAllNewsItems ? null : 5).then(({ data, error }) => {
            setIsLoading(false);

            if (error) {
                setError(error);
                return;
            }

            if (data) {
                let newsItemsData = data;

                if (!showAllNewsItems && newsItemsData.length > 4) {
                    newsItemsData = newsItemsData.slice(0, 4);
                    setShowMoreButton(true);
                }

                setNewsItems(newsItemsData);
            }
        });
    }
    return (
        <>
            <Title1>Nieuws</Title1>
            { isLoading && <Spinner /> }
            { error && <Caption1>{ error }</Caption1> }
            <div className={`flex flex-wrap flex-align-center flex-gap-medium flex-justify-center flex-align-stretch`}>
                { newsItems && newsItems.length > 0 &&
                    newsItems.map((newsItem: NewsModel) => (
                        <NewsItem key={newsItem.id} newsItem={newsItem} loggedIn={isAdmin} onClose={() => fetchNews()} />
                    ))
                }
            </div>
            <div className={`flex flex-align-center flex-gap-medium flex-justify-center`}>
                {
                    showMoreButton &&
                    <Button as={`a`} className={`button`} appearance={`subtle`} onClick={() => navigateToPage(`news`)} >
                        Ga naar alle nieuwsitems <ArrowCircleRightRegular />
                    </Button>
                }
            </div>
            { isAdmin &&
                <div className={`pos-sticky pos-bottom flex flex-justify-center width-100 mt-medium`}>
                    <div className={`flex flex-gap-medium flex-wrap actions-container`}>
                        <NewsDialog key={`${new Date()}`} newsItem={undefined} onClose={() => fetchNews()}/>
                    </div>
                </div>
            }
        </>
    );
}

export default News;